import React, {useContext} from 'react'
import {Breadcrumb, Dropdown, IconSettings} from '@salesforce/design-system-react'

import {MessagesContext} from '../context/messagesContext'

const BreadcrumbControl = () => {

  const {pages, setPages} = useContext(MessagesContext)

  const gotoPage = (index) => {
    setPages(prevPages => prevPages.slice(0, index + 1))
  }

  const trail = pages.map( (page, i) => {
    return <a
        id={`breadcrumb-${i}`}
        href='#'
        onClick={() => gotoPage(i)}
      >
        {page.title}
      </a>
  })

  return (
    <IconSettings iconPath="/icons">
      <Breadcrumb
        assistiveText={{ label: 'Breadcrumb' }}
        trail={trail}
      />
    </IconSettings>
  )
}

export default BreadcrumbControl